// GroundTruth (xAd) ad pixels for Angela's paid campaigns (geofencing around
// conferences). IDs come from her pixel sheet, Oct 2026. The degreedata.com
// pixels (293739 / 293741) belong on the marketing site, not here.
//
// Production only, like GA4 in public/index.html: staging is built from the
// same code, and test sessions and demos must not count as ad traffic.
// Each image request carries a fresh timestamp as the cache-buster the sheet's
// {TIMESTAMP} placeholder asks for.
const PRODUCTION_HOST = "curriculumfinder.degreedata.com";

const RETARGETING_URL = "https://p.xad.com?id=293747&sid=9169469&ts=";
const CONVERSION_URL = "https://bidagent.xad.com/conv/293744?ts=";

function fire(url) {
  if (window.location.hostname !== PRODUCTION_HOST) return;
  try {
    new Image(1, 1).src = url + Date.now();
  } catch (e) {
    // Ad tracking must never break the app.
  }
}

// Once per page load: the app has no router, so one load is one visit.
export function trackSiteVisit() {
  fire(RETARGETING_URL);
}

// A completed free-trial signup.
export function trackTrialSignup() {
  fire(CONVERSION_URL);
}
